import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, Construction } from 'lucide-react';
import { getCategory, getToolByIds } from '../registry';

/**
 * Fallback page for `/tools/:category/:toolId` entries marked
 * `status: 'planned'` in the registry. Keeps the URL accessible
 * (for shared bookmarks / sidebar links) without committing to a
 * half-built tool. Two affordances: jump back to the category, or
 * back to the toolbox overview.
 *
 * Intentionally has no "vote" / "subscribe" widgets — those would
 * need a backend (out of scope for individual local-dev usage).
 */
export default function ToolPlaceholder() {
  const { category, toolId } = useParams<{ category?: string; toolId?: string }>();
  const cat = getCategory(category);
  const tool = category && toolId ? getToolByIds(category, toolId) : undefined;

  const title = tool?.name ?? toolId ?? '未知工具';
  const desc = tool?.description ?? '该路径在工具注册表中没有匹配项。';

  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 p-8">
      <div className="card-pad max-w-xl text-center">
        <div className="mx-auto mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-amber-500/10 text-amber-500 dark:text-amber-400">
          <Construction className="h-5 w-5" />
        </div>
        <h1 className="text-lg font-semibold text-ink">{title} · 暂未实现</h1>
        <p className="mt-1 text-sm text-ink-muted">{desc}</p>
        <p className="mt-3 text-[12px] text-ink-dim">
          {tool
            ? '该工具已经在注册表中占位，等待具体实现。'
            : '请检查 URL；如果你是从注册表跳来的，请提交 issue。'}
        </p>

        <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
          {cat && (
            <Link
              to={`/tools/${cat.id}`}
              className="btn"
              title={`返回 ${cat.label} 分类`}
            >
              <ArrowLeft className="h-3.5 w-3.5" />
              返回 {cat.shortLabel} 分类
            </Link>
          )}
          <Link to="/tools" className="btn-ghost" title="返回工具广场">
            返回工具广场
          </Link>
        </div>
      </div>
    </div>
  );
}
